import { createCachedSelector, defaultKeySelector, path } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { detailsSidebarStoreSelector } from '../detailsSidebar.selector';

export const detailsSidebarResourceIdSelector = createCachedSelector(
  [
    path(detailsSidebarStoreSelector).id(),
  ],
  (id) => {
    return id;
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
